/**
 * AnalyzesMenu — Alpine.js компонент для бокового меню детальной страницы анализа.
 * Подсвечивает активный пункт при скроле (IntersectionObserver) и при клике.
 */
export default () => ({
    activeSection: 'general',
    _observers: [],
    _clicking: false,
    _clickTimer: null,

    init() {
        // Запускаем наблюдение за секциями через IntersectionObserver
        this._observe();
    },

    destroy() {
        this._observers.forEach(o => o.disconnect());
        if (this._clickTimer) clearTimeout(this._clickTimer);
    },

    _observe() {
        const sectionIds = ['general', 'preparation', 'indications', 'description'];

        const options = {
            root: null,
            // Срабатывает когда секция занимает верхние 30% экрана
            rootMargin: '-10% 0px -60% 0px',
            threshold: 0,
        };

        sectionIds.forEach(id => {
            const el = document.getElementById(id);
            if (!el) return;

            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    // Не меняем активную секцию если пользователь только что кликнул
                    if (this._clicking) return;
                    if (entry.isIntersecting) {
                        this.activeSection = id;
                    }
                });
            }, options);

            observer.observe(el);
            this._observers.push(observer);
        });
    },

    /**
     * Вызывается при клике на пункт меню.
     * Немедленно ставит секцию активной и блокирует IntersectionObserver
     * на время анимации скрола (~800ms), чтобы не было «прыжков».
     */
    setActive(section) {
        this.activeSection = section;
        this._clicking = true;

        if (this._clickTimer) clearTimeout(this._clickTimer);
        this._clickTimer = setTimeout(() => {
            this._clicking = false;
        }, 900);
    },

    isActive(section) {
        return this.activeSection === section;
    },
});
